import { Camera, Cameras } from './CameraSettingsState';
import { AutoIsoObjectType } from '@/features/autoIso/types';
import { AutoDirectorConfig } from '@/shared/types/GameStateModel';

/** Value used on the server to represent that no tracking ID is set. */

export enum ViewType {
  MOSAIC = 'mosaic',
  SINGLE_CAMERA = 'single',
  NONE = 'none',
}

export type ServerState = {
  cameras: Cameras;
  selectedCameraId: number;
  selectedCamera: Camera | undefined;
  selectedTrackedEntity: number;
  autoDirectorEnabled: boolean;
  // False when the player reports no auto_director block (e.g. a single-camera rig).
  autoDirectorAvailable: boolean;
  autoDirectorConfig: AutoDirectorConfig;
  selectedObjectType?: AutoIsoObjectType;
  viewType: ViewType;
  switch: {
    isSwitchingView: boolean;
    isSwitchingTrackedEntity: boolean;
    isSwitchingCamera: boolean;
    errorSwitchingCamera: boolean;
    errorSwitchingTrackedEntity: boolean;
    errorSwitchingView: boolean;
  };
};

export type VideoSource = ViewType;
